module.exports = __webpack_public_path__ + "img/logo.18ef0f9f.svg";